import type React from 'react';
import { ClickEventNameEnum } from '../../../Curiosity/Analytics/utils/ClickEventNameEnum';
import type { HandleDealCardCtaCallBack } from '../types';

export const getCardCtaLinkProps = ({
  deepLink,
  handleDealCardCtaCallBack,
}: {
  deepLink?: string;
  handleDealCardCtaCallBack: HandleDealCardCtaCallBack;
}) => ({
  as: 'a' as const,
  href: deepLink,
  target: '_blank',
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) =>
    handleDealCardCtaCallBack({ e, payload: { event_name: ClickEventNameEnum.hotelCardClick } }),
});
